export interface KanbanViewHeaderI {
    title: string;
    name: string;
    position: number;
    duration: string;
    dropOff: string;
    dropOffHour: string;
}

export interface KanbanViewCardI {
    select: boolean;
    id: string;
    accountName: string;
    salesRep: string;
    partnerType: string;
    phone: string;
    dateCreated: string;
}

export interface KanbanViewListI {
    id: string;                     
    header: KanbanViewHeaderI,
    cards: KanbanViewCardI[]; 
}
